import { Box, Paper, Stack, Typography } from '@mui/material';
import { Descope, useSession } from '@descope/react-sdk';
import { Navigate, useLocation } from 'react-router-dom';

export function LoginPage() {
  const { isAuthenticated } = useSession();
  const location = useLocation();

  if (isAuthenticated) {
    const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? '/';
    return <Navigate to={from} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <Paper sx={{ p: 4, width: '100%', maxWidth: 440 }}>
        <Stack spacing={3} sx={{ mb: 3, textAlign: 'center' }}>
          <Typography variant="h5" color="primary" fontWeight={700}>
            BrandLight Backoffice
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sign in to manage tenants, reports, and prompts.
          </Typography>
        </Stack>

        <Descope
          flowId="sign-in"
          theme="light"
          // No-op logger: prevent Descope from logging sensitive data to the
          // console. The prop expects a Partial<Logger> object, not a function.
          logger={{ error: () => {}, warn: () => {}, info: () => {}, debug: () => {} }}
        />
      </Paper>
    </Box>
  );
}
